import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
}), 'Flag');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Flag.js
// module id = 3704
// module chunks = 2